import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { MenuService } from '../../../core/components/menu/services/menu.service';
import { AuthApp, AuthService } from '../../../core/services/auth.service';

@Component({
    selector: 'not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NotFoundComponent implements OnInit {

  routerLink: string = '';
  /** The app of the missing URL: Home and the search stay in that app */
  private app: AuthApp;

  constructor(
    public router: Router,
    public menuService: MenuService,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.app = AuthService.appForUrl(this.router.url);
  }

  public goHome(): void {
    this.router.navigateByUrl(this.authService.homeUrl(this.app));
  }

  public searchForRoute(): void {
    const keyword = this.routerLink.trim().toLowerCase();
    if (!keyword) {
      return;
    }
    const validRouterLink = this.menuService.getMenuItems(this.app)
      .map(menuItem => menuItem.routerLink)
      .find(routerLink => routerLink?.includes(keyword));
    if (validRouterLink) {
      this.router.navigateByUrl(validRouterLink);
    }
  }

}
